import { defineComponent as _defineComponent } from 'vue'
import {ref, watch, onBeforeUpdate, nextTick} from "vue"
import {useI18n} from "vue-i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'LangChangeBtn',
  setup(__props, { expose: __expose }) {
  __expose();

const menu = ref(false)
const {locale} = useI18n()
const currentLocale = ref(locale.value)

const locales = [
    {code: "ko", name: "한국어"},
    {code: "ar", name: "اللغة العربية"},
    {code: "cz", name: "Czech"},
    {code: "de", name: "German"},
    {code: "en", name: "English"},
    {code: "es", name: "Español"},
    {code: "fr", name: "Français"},
    {code: "ja", name: "日本語"},
    {code: "kz", name: "қазақ"},
    {code: "pt", name: "Português"},
    {code: "sv", name: "Svenska"},
    {code: "sh", name: "српски језик"},
    {code: "sr", name: "srpski jezik"},
    {code: "hr", name: "hrvatski"},
];

const changeLocale = (code: string) => {
    locale.value = code
    currentLocale.value = code
    menu.value = false
}

// 👉 lang-item DOM element 들 모아두는 배열
const langItemRefs = ref<HTMLElement[]>([])

const setLangItemRef = (el: HTMLElement | null, index: number) => {
    if (el) {
        langItemRefs.value[index] = el
    }
}

// v-for 다시 렌더될 때 ref 배열 초기화
onBeforeUpdate(() => {
    langItemRefs.value = []
})

// 메뉴 열릴 때, 현재 locale 에 해당하는 항목에 포커스 주기
watch(menu, async (isOpen) => {
    if (!isOpen) return

    await nextTick()
    const index = locales.findIndex((l) => l.code === currentLocale.value) || 0
    const target = langItemRefs.value[index] || langItemRefs.value[0]
    target?.focus()
})

// 키보드 이벤트 처리
const onLangItemKeydown = (
    event: KeyboardEvent,
    index: number,
    code: string
) => {
    const key = event.key

    // ↑ / ↓ 로 포커스 이동
    if (key === "ArrowDown" || key === "ArrowUp") {
        event.preventDefault()

        const lastIndex = locales.length - 1
        let nextIndex = index

        if (key === "ArrowDown") {
            nextIndex = index === lastIndex ? 0 : index + 1
        }
        else if (key === "ArrowUp") {
            nextIndex = index === 0 ? lastIndex : index - 1
        }

        const nextEl = langItemRefs.value[nextIndex]
        nextEl?.focus()
        return
    }

    // Enter / Space 로 선택
    if (key === "Enter" || key === " " || key === "Spacebar") {
        event.preventDefault()
        event.stopPropagation()
        changeLocale(code)
    }
}

const currentLocaleName = () => {
    const lang = locales.find(e => e.code === currentLocale.value)
    return lang ? lang.name : "없음"
}


const __returned__ = { menu, locale, currentLocale, locales, changeLocale, langItemRefs, setLangItemRef, onLangItemKeydown, currentLocaleName }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})